import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { IArticle } from '../../models/IArticle.type';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-article',
  templateUrl: './card-article.component.html'
})
export class CardArticleComponent implements OnInit {
  @Input() articles:IArticle[];
  @Output() singleArticle = new EventEmitter<number>();

  constructor(private router: Router,) { }

  ngOnInit(): void {
  }

  getSingleArticle(id){
    this.singleArticle.emit(id);
  }

}
